import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { faAngleLeft, faArrowLeft, faGear, faHome, fas, faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import style from "./RenewMobileHeader.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import NiceModal from "@ebay/nice-modal-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cart from "routes/front/header/CartButton";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import { ReactComponent as Logo1 } from "resources/img/logo/logo.svg";
import { ReactComponent as Logo2 } from "resources/img/logo/01.svg";
import { ReactComponent as Logo3 } from "resources/img/logo/02.svg";
import { ReactComponent as Logo4 } from "resources/img/logo/03.svg";
import { ReactComponent as Logo5 } from "resources/img/logo/04.svg";
import { ReactComponent as Logo6 } from "resources/img/logo/05.svg";
import { faMessage } from "@fortawesome/free-regular-svg-icons";
import P from "components/P";
import BackButton from "components/buttons/BackButton";
import Center from "layouts/wrapper/Center";
import { ReactComponent as HomeIcon } from "resources/img/icons/home.svg";
import CustomIcon from "components/icons/CustomIcon";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import LanguageSwitcher from "components/countryFlag/MobileLanguageSwitcher";
import MobileSearchBar from "components/MobileSearchBar";
import WorldvapeLogo from "resources/img/logo/worldvape_logo.png";
import settingIcon from "resources/img/vending/setting.png";
import cartIcon from "resources/img/vending/cartIcon.png.png"
import { AuthContext } from "providers/AuthProvider";
import { useContext } from "react";

function RenewMobileHeader() {

    const location = useLocation();

    const { userName } = useContext(AuthContext);
    const onSideMenuClick = () => {
        NiceModal.show("sideMenu", { userName: userName });
    }

    let headerText = "";
    if (location.pathname.includes("storeList")) {
        headerText = "매장선택";
    } else if (location.pathname.includes("list")) {
        headerText = "주문하기";
    } else if (location.pathname.includes("mypage")){
        headerText = "마이페이지";
    }else if (location.pathname.includes("main")){
        headerText = "메인";
    } 

    return (
        <div>
            <div className={style.container}>
                <VerticalFlex>
                    <FlexChild height={50}>
                        <HorizontalFlex gap={10}>
                            <FlexChild width={65}>
                                <div className={style.sideMenuButton} onClick={onSideMenuClick}>
                                        <FontAwesomeIcon icon={fas["faChevronLeft"]} color={"#000000"} size="lg" />
                                </div>
                            </FlexChild>
                            <FlexChild justifyContent={"center"}>
                                <P size={20} weight={500}>{headerText}</P>
                            </FlexChild>
                            <FlexChild width={70}>

                                <HorizontalFlex>
                                    <FlexChild>
                                        <Link to={"/"}>
                                            {/* <Center>
                                                <img className={style.logoIcon} src={settingIcon} />
                                            </Center> */}
                                            <Center>
                                                <FontAwesomeIcon icon={fas["faMagnifyingGlass"]} color={"#000000"} size="lg" />
                                            </Center>
                                        </Link>
                                    </FlexChild>

                                    <FlexChild>
                                        <Link to={"/"}>
                                            {/* <Center>
                                                <img className={style.logoIcon} src={cartIcon} />
                                            </Center> */}
                                            <Center>
                                                <FontAwesomeIcon icon={fas["faCartShopping"]} color={"#000000"} size="lg" />
                                            </Center>
                                        </Link>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            {/* <FlexChild>
                            <MobileSearchBar />
                        </FlexChild> */}


                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </div>
        </div>
    )

}
export default RenewMobileHeader